import EnumSealSource from "./gen/qsign/types/EnumSealSource";
const labels = {
  [EnumSealSource.MC]: "Marbes",
  [EnumSealSource.REMSIG]: "Remsig",
  [EnumSealSource.SECUSIGN]: "SecuSign",
  [EnumSealSource.ICA]: "ICA",
  [EnumSealSource.QSEAL]: "QSeal",
};
export function getCaption(source: EnumSealSource) {
  const caption = labels[source];
  return caption ? caption : "[" + source + "]";
}
